import React from "react"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import ChooseHierarchyPickerDialog from "../hierarchy/choose_hierarchy/ChooseHierarchyPickerDialog"
import AccountStore from "../../stores/AccountStore"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AppStateStore from "../../stores/AppStateStore"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { ELoggedInUserType, IHierarchyItemForAccountLevel } from "../../models"
import * as setGlobalHierarchyLevel from "../../helpers/setGlobalHierarchyLevel"
import * as hierarchySettingsActions from "../../actions/HierarchySettingsActions"
import * as userHelper from "../../helpers/userHelper"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
interface IProps {
    loggedInUserType: ELoggedInUserType
}
interface IState {
    openHierarchyPickerDialog: boolean
    globalLevelItemPathToRoot: IHierarchyItemForAccountLevel[]
}

export default class GlobalFilterHierarchyNavItem extends React.Component<IProps, IState>  {
    private globalLevelMaxCount = 20
    private cutOffWordLength = 10
    constructor(props) {
        super(props)
        this.state = {
            openHierarchyPickerDialog: false,
            globalLevelItemPathToRoot: HierarchySettingsStore.getSelectedLevelItemPathToRoot()
        }
        autobind(this)
    }

    componentDidMount() {
        HierarchySettingsStore.on("global_change", this.changeEvent)
    }

    componentWillUnmount() {
        HierarchySettingsStore.removeListener("global_change", this.changeEvent)
    }

    changeEvent() {
        this.setState({ globalLevelItemPathToRoot: HierarchySettingsStore.getSelectedLevelItemPathToRoot() })
    }

    hierarchyNavTouch() {
        if (this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee) {
            hierarchySettingsActions.receiveHierarchySelectedItem(HierarchySettingsStore.getGlobalLevelItemFilter())
            this.setState({ openHierarchyPickerDialog: true })
        }
    }

    onClickHierarchyParentItem(selectedHierarchyItemData) {
        if (this.props.loggedInUserType === AuthenticationStore.LoggedInUserTypes.Employee) return
        const hierarchyItem = selectedHierarchyItemData.level === -1 ? null : selectedHierarchyItemData.hierarchyItem
        userHelper.getSupervisorAccessPermissionForHierarchy(hierarchyItem) ?
            setGlobalHierarchyLevel.setGlobalHierarchyLevel(hierarchyItem) :
            AppStateStore.setProgressSnackbarContent(strings.You_cant_access_this_hierarchy_item)
    }

    render() {
        if (!AccountStore.getHierarchyEnabled())
            return <span />
        const levelDefinitionName = HierarchySettingsStore.getGlobalLevelItemFilterId() ?
            hierarchyHelper.getHierarchyDefinitionNameByHierarchyId(HierarchySettingsStore.getGlobalLevelItemFilterId()) :
            strings.Account
        const levelName = HierarchySettingsStore.getGlobalLevelItemFilter() ? HierarchySettingsStore.getGlobalLevelItemFilter().Label : AccountStore.getCurrentAccount().Name
        return (
            <div className="HierarchyNavItem" style={{ overflow: "hidden", whiteSpace: "nowrap" }}>
                <div style={{ display: "inline-block" }}>
                    {this.state.globalLevelItemPathToRoot.length > 5 &&
                        <div style={{ display: "inline-block", fontSize: 25, paddingRight: 15, color: "rgb(164, 178, 185)" }}>
                            ...
                        </div>
                    }
                    {this.state.globalLevelItemPathToRoot
                        .filter((item, index) =>
                            this.state.globalLevelItemPathToRoot.length - 1 !== index &&
                            (this.state.globalLevelItemPathToRoot.length - index) < 6
                        )
                        .map((item, index) => {
                            let definitionLabel = item.hierarchyDefinition.Label
                            let definitionLabelTitle = ""
                            let itemLabel = item.hierarchyItem.Label
                            if (this.state.globalLevelItemPathToRoot.length > 3) {
                                if (definitionLabel.length > this.cutOffWordLength) {
                                    definitionLabelTitle = definitionLabel
                                    definitionLabel = definitionLabel.slice(0, this.cutOffWordLength) + "..."
                                }
                                if (itemLabel.length > 10) {
                                    itemLabel = itemLabel.slice(0, 10) + "..."
                                }
                            }
                            return (
                                <div
                                    key={index}
                                    style={{ display: "inline-block", paddingRight: 15 }}
                                    onClick={() => this.onClickHierarchyParentItem(item)}
                                >
                                    <div style={{ float: "left" }}>
                                        <div
                                            title={definitionLabelTitle}
                                            style={{ fontSize: 10, textAlign: "right", color: "rgb(164, 178, 185)" }}
                                        >
                                            {definitionLabel}
                                        </div>
                                        <div style={{ fontSize: 18, marginTop: -5, color: "rgb(164, 178, 185)", textAlign: "right" }}>
                                            {itemLabel}
                                        </div>
                                    </div>
                                    <div style={{ float: "left", fontSize: 18, padding: 5, paddingLeft: 15, color: "rgb(39, 46, 49)" }}>
                                        <i className="fa fa-angle-right" />
                                    </div>
                                    <div style={{ clear: "both" }} />
                                </div>
                            )
                        })}
                </div>
                <div
                    className="topNavFilter"
                    style={{ display: "inline-block", textAlign: "right", paddingRight: 15 }}
                    onClick={() =>
                        this.props.loggedInUserType !== AuthenticationStore.LoggedInUserTypes.Employee &&
                        this.setState({ openHierarchyPickerDialog: true }, () =>
                            hierarchySettingsActions.receiveHierarchySelectedItem(HierarchySettingsStore.getGlobalLevelItemFilter())
                        )
                    }
                >
                    <div style={{ float: "left" }}>
                        <div style={{ fontSize: 12, textAlign: "right" }}>
                            {levelDefinitionName}
                        </div>
                        <div
                            style={{ fontSize: 24, marginTop: -5, color: "rgb(237, 246, 251)", textAlign: "right", maxWidth: 400, textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            title={levelName.length > this.globalLevelMaxCount ? levelName : ""}
                        >
                            {levelName.length > this.globalLevelMaxCount ?
                                levelName.substring(0, this.globalLevelMaxCount) + "..." :
                                levelName
                            }
                        </div>
                    </div>
                    <div style={{ float: "left", fontSize: 18, padding: 5, paddingLeft: 10 }}>
                        <i className="fa fa-chevron-down" />
                    </div>
                    <div style={{ clear: "both" }} />
                </div>
                <div style={{ clear: "both" }} />
                {this.state.openHierarchyPickerDialog &&
                    <ChooseHierarchyPickerDialog
                        handleSave={selectedLevel => setGlobalHierarchyLevel.setGlobalHierarchyLevel(selectedLevel)}
                        handleClose={() => this.setState({ openHierarchyPickerDialog: false })}
                    />
                }
            </div>
        )
    }
}